import { render, staticRenderFns } from "./PointOfSale.vue?vue&type=template&id=1af9731f&scoped=true&"
import script from "./PointOfSale.vue?vue&type=script&lang=js&"
export * from "./PointOfSale.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9731f",
  null
  
)

export default component.exports